const isLocal = process.env.REACT_APP_IS_LOCAL || 'false';
export const BACKEND_URL = isLocal === 'true' ? 'http://localhost:3001' : process.env.REACT_APP_BACKEND_URL;
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL;
export const PRIVATE_KEY = process.env.REACT_APP_PRIVATE_KEY;
// plots pagination
export const PLOTS_INITIAL_NR = 5;
export const PLOTS_LOAD_MORE = 2;
